import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { Part } from '../../../opc-app/part/part.model';
import { Message, ConfirmationService } from 'primeng/api';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { PartService } from '../../../shared/services/part.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { OPCConstant } from '../../../opc-app/opc.const';
import { PartGroup } from '../../../opc-app/partgroup/partgroup.model';
import { ColorCode } from '../../../opc-app/part/colorcode.model';
import { OPCSettings } from '../../../shared/models/opcsettings.model';

@Component({
  selector: 'app-part-item',
  templateUrl: './part-item.component.html'
})
export class PartItemComponent implements OnInit {
  @Input() part: Part;
  @Input() parts: Part[];
  @Input() partGroup: PartGroup;
  @Input() colorCodes: ColorCode[];
  @Input() i: string;
  @Output() isSubmited: EventEmitter<any> = new EventEmitter();
  @Output() isDeleted: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload')
  fileUpload: any;
  clonePart: Part;
  file: any;
  notifications: Message[] = [];
  pName: string;
  pFormGroup: FormGroup;
  partPricing: FormGroup;
  showImage: boolean;
  partGroups: PartGroup[];
  partGroupDesc: string;
  pkgIndex: number;
  opcSettings: OPCSettings = new OPCSettings();
  handlingOptions: any[] = ['LH', 'RH', 'AP/PA'];
  viewColor: string;
  numPattern = '^[0-9,]+(?:\,[0-9]+)?$';//'^\d{1,3}(,\d{3})$';//'^[1-9][0-9,]$';//'^[1-9][0-9]$';
  pricePattern = '[0-9]+(\.[0-9][0-9]?)?';
  backgroundColorCode: string;
  rollIndex: number;
  palletIndex: number;

  constructor(private _partService: PartService, private confirmationService: ConfirmationService,
    private notifyService: NotificationService, private fb: FormBuilder) {
  }

  ngOnInit() {
    this.pName = this.part.partDesc ? this.part.partDesc : '';
    this.partGroupDesc = this.partGroup.partGroupDesc ? this.partGroup.partGroupDesc : '';
    this.clonePart = Object.assign({}, this.part);
    this.pkgIndex = this.pName !== '' ? this.part.packageType.trim().toLowerCase().indexOf('pkg') : -1;
    this.rollIndex = this.pName !== '' ? this.part.packageType.trim().toLowerCase().indexOf('roll') : -1;
    this.palletIndex = this.pName !== '' ? this.part.packageType.trim().toLowerCase().indexOf('pallet') : -1;
    this.pName !== '' ? this.formGroupValidation() : this.createNewPartFormGroup();
    this.pFormGroup.controls.quantity.clearValidators();
  }
  createNewPartFormGroup() {
    this.partPricing = this.fb.group({
      partID: [0],
      partPricingID: [0],
      isActive: [true],
      retailPrice: [0.00],
      wholesalePrice: [0.00, [Validators.min(0),
      Validators.pattern(this.pricePattern)]],
      salesUnit: [null],
      minSalesPrice: [0.00],
      maxSalesPrice: [0.00],
      costPrice: [0.00]
    });
    this.pFormGroup = this.fb.group({
      partID: [0],
      partNumber: ['', [Validators.required, Validators.maxLength(20), Validators.minLength(7)]],
      colorCodeID: [],
      packageType: [this.part.packageType, [Validators.required]],
      quantity: [2],
      rollQuantity: [2],
      palletquantity: [2],
      handling: [''],
      isServiceReimbursable: [false],
      warrantyPeriod: [],
      partDesc: ['', [Validators.required, Validators.maxLength(60), Validators.minLength(3)]],
      partGroupId: [this.partGroup.partGroupID],
      isDefault: [false],
      isActive: [true],
      isDiscontinued: [false],
      size: [],
      partEffectiveDate: ['', [Validators.required]],
      partEndDate: [],
      replacementPartID: [0],
      replacementPartNumber: [],
      keywords: [],
      length: [],
      partPricing: this.partPricing,
      notes: ['', [Validators.maxLength(250)]]
    });
  }
  formGroupValidation() {
    this.partPricing = this.fb.group({
      partID: [this.part.partID],
      partPricingID: [this.part.partPricing.partPricingID],
      isActive: [this.part.partPricing.isActive],
      retailPrice: [this.part.partPricing.retailPrice],
      wholesalePrice: [this.part.partPricing.wholesalePrice, [Validators.min(0),
      Validators.pattern(this.pricePattern)]],
      salesUnit: [this.part.partPricing.salesUnit],
      minSalesPrice: [this.part.partPricing.minSalesPrice],
      maxSalesPrice: [this.part.partPricing.maxSalesPrice],
      costPrice: [this.part.partPricing.costPrice],
      createdDt: [this.part.partPricing.createdDt]
    });
    this.pFormGroup = this.fb.group({
      partID: [this.part.partID],
      partNumber: [this.part.partNumber, [Validators.required, Validators.maxLength(20), Validators.minLength(7)]],
      colorCodeID: [this.part.colorCodeID],
      packageType: [this.pkgIndex !== -1 ? 'pkg' : this.rollIndex !== -1 ? 'roll' : this.part.packageType, [Validators.required]],
      quantity: [this.pkgIndex !== -1 ? this.part.quantity.toLocaleString('en-US') : 2,
      [Validators.required, Validators.min(2), Validators.pattern(this.numPattern)]],
      rollQuantity: [this.rollIndex !== -1 ? this.part.quantity.toLocaleString('en-US') : 2,
      [Validators.required, Validators.pattern(this.numPattern)]],
      palletquantity: [this.palletIndex !== -1 ? this.part.quantity.toLocaleString('en-US') : 2,
      [Validators.required, Validators.pattern(this.numPattern)]],
      handling: [this.part.handling],
      isServiceReimbursable: [this.part.isServiceReimbursable],
      warrantyPeriod: [this.part.warrantyPeriod],
      partDesc: [this.part.partDesc, [Validators.required, Validators.maxLength(60), Validators.minLength(3)]],
      partGroupID: [this.part.partGroupID],
      isDefault: [this.part.isDefault],
      isActive: [this.part.isActive],
      isDiscontinued: [this.part.isDiscontinued],
      size: [this.part.size],
      partEffectiveDate: [this.formatDate(this.part.partEffectiveDate), [Validators.required]],
      partEndDate: [this.part.partEndDate ? this.formatDate(this.part.partEndDate) : null],
      replacementPartNumber: [this.getReplacementPartNumber()],
      replacementPartID: [this.part.replacementPartID],
      keywords: [this.part.keywords],
      length: [this.part.length],
      partPricing: this.partPricing,
      notes: [this.part.notes, Validators.maxLength(250)]
    });
    this.onColorChange();
  }
  onSubmit() {
    if (this.pFormGroup.valid) {
      if (this.pFormGroup.controls.packageType.value === 'pkg') {
        this.pFormGroup.controls.packageType.setValue('pkg');
      }
      else if (this.pFormGroup.controls.packageType.value === 'roll') {
        this.pFormGroup.controls.packageType.setValue('roll');
        this.pFormGroup.controls.quantity.setValue(this.pFormGroup.controls.rollQuantity.value);
      }
      else if (this.pFormGroup.controls.packageType.value === 'pallet') {
        this.pFormGroup.controls.packageType.setValue('pallet');
        this.pFormGroup.controls.quantity.setValue(this.pFormGroup.controls.palletquantity.value);
      }
      else if (this.pFormGroup.controls.packageType.value === 'unit' ) {
        this.pFormGroup.controls.quantity.setValue(1);
      }
      if (this.pFormGroup.controls.handling.value === "") {
        this.pFormGroup.controls.handling.setValue(null);
      }
      if (this.pFormGroup.controls.size.value === "") {
        this.pFormGroup.controls.size.setValue(null);
      }
      if (this.pFormGroup.controls.length.value === "") {
        this.pFormGroup.controls.length.setValue(null);
      }
      this._partService.addOrUpdatePart(this.pFormGroup.value, this.pName).subscribe((res: FormGroup) => {
        this.isSubmited.emit(res);
      },
        error => {
          this.notifications = this.notifyService.growlNotification('fail', OPCConstant.ADDED_FAILURE);
          this.isSubmited.emit(undefined);
        }
      );
    }
  }
  onExpand() {
    // TO DO
  }

  numberFormatChange(e) {
    if (e.target.value != "") {
      var quantity = parseInt(e.target.value.replace(/,/g, ''))
      if (quantity.toString() != "NaN" && quantity.toString() != 'undefined') {
        var pkg = (quantity.toLocaleString('en-US'));
        var pkgtype = this.pFormGroup.controls.packageType.value;
        if (pkgtype === 'pkg') {
          this.pFormGroup.controls.quantity.setValue(pkg);
        }
        else if (pkgtype === 'roll') {
          this.pFormGroup.controls.rollQuantity.setValue(pkg);
        }
        else if (pkgtype === 'pallet') {
          this.pFormGroup.controls.palletquantity.setValue(pkg);
        }
        if (quantity > 2) {
          this.pFormGroup.controls.quantity.updateValueAndValidity();
          this.pFormGroup.controls.rollQuantity.updateValueAndValidity();
          this.pFormGroup.controls.quantity.clearValidators();
          this.pFormGroup.controls.rollQuantity.clearValidators();
          this.pFormGroup.controls.quantity.clearValidators();
          this.pFormGroup.controls.palletquantity.clearValidators();
        }
      }
    }
    if (e.target.value == "" || quantity.toString() == "NaN" && quantity.toString() == 'undefined' || quantity < 2) {
      this.pFormGroup.controls.quantity.setValidators(
        [Validators.required, Validators.min(2), Validators.pattern(this.numPattern)]);
      this.pFormGroup.controls.rollQuantity.setValidators(
        [Validators.required, Validators.min(2), Validators.pattern(this.numPattern)]);
      this.pFormGroup.controls.palletquantity.setValidators(
        [Validators.required, Validators.min(2), Validators.pattern(this.numPattern)]);
    }
    this.pFormGroup.controls.quantity.updateValueAndValidity();
    this.pFormGroup.controls.rollQuantity.updateValueAndValidity();
    this.pFormGroup.controls.palletquantity.updateValueAndValidity();
  }


  onColorChange() {
    try {
      var codeId = this.pFormGroup.controls.colorCodeID.value
      var colorCodeDesc = this.colorCodes.find(c => c.colorCodeID == codeId).colorCodeDesc;
      var colorCode = this.colorCodes.find(c => c.colorCodeID == codeId).code;
      this.backgroundColorCode = '-webkit-linear-gradient(-61deg, white 50%, white 50%)';
      this.viewColor = 'white';
      if (colorCodeDesc.indexOf('/') > -1 && colorCodeDesc !== 'none' || colorCode.indexOf('/') > -1) {
        var colorCodeList = colorCode.includes('/') ? colorCode.split("/") : colorCodeDesc.split('/');
        var colorCode1 = this.colorCodes.find(c => c.code === colorCodeList[0] || c.colorCodeDesc === colorCodeList[0] && c.cssColorCode != null) ? this.colorCodes.find(c => c.code === colorCodeList[0] || c.colorCodeDesc === colorCodeList[0] && c.cssColorCode != null).cssColorCode : 'white';
        var colorCode2 = this.colorCodes.find(c => c.code === colorCodeList[1] || c.colorCodeDesc === colorCodeList[1] && c.cssColorCode != null) ? this.colorCodes.find(c => c.code === colorCodeList[1] || c.colorCodeDesc === colorCodeList[1] && c.cssColorCode != null).cssColorCode : 'white';
        var TempcolorCode1 = colorCode1 == null ? 'white' : colorCode1;
        var TempcolorCode2 = colorCode2 == null ? 'white' : colorCode2;
        this.backgroundColorCode = '-webkit-linear-gradient(-61deg,' + TempcolorCode1 + ' 49%, ' + TempcolorCode2 + ' 51%)';
        this.viewColor = this.backgroundColorCode;
      }
      else {
        if (colorCodeDesc == 'none') {
          var color = '#FFFFFF'
        } else {
          var color = this.colorCodes.find(c => c.colorCodeID == codeId).cssColorCode;
        }
        var TempcolorCode = color == null ? 'white' : color;
        this.backgroundColorCode = '-webkit-linear-gradient(-61deg,' + TempcolorCode + ' 50%, ' + TempcolorCode + ' 50%)';
        this.viewColor = this.backgroundColorCode;
      }
    }
    catch (error) {
    }
  }


  verifyPartNumbers() {
    if (this.pFormGroup.controls.partNumber.value !== this.part.partNumber) {
      this._partService.verifyPartNumbers(this.pFormGroup.controls.partNumber.value).subscribe(res => {
        if (res) {
          this.pFormGroup.controls.partNumber.setErrors({
            verifyFailure: true
          });
        }
      });
    }
  }
  verifyReplacementPartNumber() {
    if (this.pFormGroup.controls.replacementPartNumber.value) {
      const partID = this.parts.find(p => p.partNumber === this.pFormGroup.controls.replacementPartNumber.value)
        && this.part.partNumber !== this.pFormGroup.controls.replacementPartNumber.value ?
        this.parts.find(p => p.partNumber === this.pFormGroup.controls.replacementPartNumber.value).partID : 0;
      if (partID) {
        this.pFormGroup.controls.replacementPartID.setValue(partID);
        this.pFormGroup.controls.replacementPartNumber.setErrors(null);
        return null;
      } else {
        this.pFormGroup.controls.replacementPartID.setValue(0);
        this.pFormGroup.controls.replacementPartNumber.setErrors({
          verifyFailure: true
        });
      }
    } else {
      this.pFormGroup.controls.replacementPartID.setValue(0);
    }
  }
  onDiscontinued() {
    if (!this.pFormGroup.controls.isDiscontinued.value) {
      this.pFormGroup.controls.replacementPartNumber.setValue('');
    }
  }
  onPkgValueChange() {
    if (this.pFormGroup.controls.packageType.value === 'unit') {
      this.pFormGroup.controls.quantity.setValue(2);
      this.pFormGroup.controls.rollQuantity.setValue(2);
      this.pFormGroup.controls.quantity.clearValidators();
      this.pFormGroup.controls.rollQuantity.clearValidators();
      this.pFormGroup.controls.palletquantity.clearValidators();
    }
    else if (this.pFormGroup.controls.packageType.value === 'pkg') {
      this.pFormGroup.controls.rollQuantity.clearValidators();
      this.pFormGroup.controls.quantity.setValue(2);
      this.pFormGroup.controls.quantity.setValidators(
        [Validators.required, Validators.min(2), Validators.pattern(this.numPattern)]);
    }
    else if (this.pFormGroup.controls.packageType.value === 'roll') {
      this.pFormGroup.controls.quantity.clearValidators();
      this.pFormGroup.controls.rollQuantity.setValue(2);
      this.pFormGroup.controls.rollQuantity.setValidators(
        [Validators.required, Validators.min(2), Validators.pattern(this.numPattern)]);
    }
    else if (this.pFormGroup.controls.packageType.value === 'pallet') {
      this.pFormGroup.controls.quantity.clearValidators();
      this.pFormGroup.controls.palletquantity.setValue(2);
      this.pFormGroup.controls.palletquantity.setValidators(
        [Validators.required, Validators.min(2), Validators.pattern(this.numPattern)]);
    }
    this.pFormGroup.controls.quantity.updateValueAndValidity();
    this.pFormGroup.controls.rollQuantity.updateValueAndValidity();
    this.pFormGroup.controls.palletquantity.updateValueAndValidity();
  }

  onDelete(item: number, index: string) {
    if (item) {
      this.confirmationService.confirm({
        header: 'Delete Confirmation',
        key: index,
        message: OPCConstant.CONFIRM_MESSAGE,
        accept: () => {
          this._partService.deletePart(item).subscribe(
            res => {
              this.isDeleted.emit(true);
            },
            error => {
              this.isDeleted.emit(false);
              this.notifications = this.notifyService.growlNotification('fail', OPCConstant.PC_DELETE_FAILURE);
            }
          );
        }
      });
    } else {
      this.isDeleted.emit(true);
    }
  }
  onReset() {
    this.part = Object.assign({}, this.clonePart);
    this.part.partDesc ? this.formGroupValidation() : this.createNewPartFormGroup();
    if (this.part.partID === 0) {
      this.pFormGroup.reset();
    }
  }
  formatDate(value) {
    const date = new Date(value);
    return date;
  }
  getDate(value) {
    const date = new Date(value);
    date.setDate(date.getDate() + 1);
    return date;
  }
  getTodayDate() {
    return new Date();
  }
  getReplacementPartNumber() {
    const partnum = this.parts.find(p => (p.partID === this.part.replacementPartID)) ?
      this.parts.find(p => p.partID === this.part.replacementPartID).partNumber : '';
    return partnum;
  }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/part/part-item/part-item.component.ts